import { DestroyRef, Directive, inject, Renderer2 } from '@angular/core';
import { outputToObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Popover } from 'primeng/popover';

@Directive({
  selector: '[pinnaklPopoverRight]',
})
export class PopoverRightDirective {
  private readonly destroyRef = inject(DestroyRef);
  private readonly popover = inject(Popover);
  private readonly renderer = inject(Renderer2);

  constructor() {
    outputToObservable(this.popover.onShow)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.alignRight());
  }

  private alignRight(): void {
    const container = this.popover.container;
    if (!container) return;

    this.renderer.setStyle(container, 'transform', 'translateY(0) translateX(0)');
    this.renderer.setStyle(container, 'right', '0');
    this.renderer.setStyle(container, 'left', 'auto');
  }
}
